<script lang="ts">
	import type { TLocaleGroup } from "@xbs/lib-kanban";
	import { getContext } from "svelte";
	export const locale = getContext<any>("wx-i18n");
	export const _: TLocaleGroup = locale.getGroup("kanban");

</script>
